import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    cartProducts: [],
};

const shoppingCartProducts = createSlice({
    name: "cartProducts",
    initialState,
    reducers: {
        setCartProducts: (state, action) => {
            state.cartProducts = action.payload;
        },
    },
});

export const { setCartProducts } = shoppingCartProducts.actions;

export default shoppingCartProducts.reducer;
